import PropTypes from 'prop-types';
import { useState } from 'react';
import { MdChat, MdCheck, MdClose, MdHourglassEmpty } from 'react-icons/md';
import styles from './FeedbackSection.module.css';

const FeedbackSection = ({ 
  onRegenerate, 
  isLoading, 
  isStreaming, 
}) => {
  const [showFeedback, setShowFeedback] = useState(false);
  const [feedbackText, setFeedbackText] = useState('');
  const [enhancePromptEnabled, setEnhancePromptEnabled] = useState(false);

  const handleSubmit = () => {
    if (feedbackText.trim() && onRegenerate) {
      onRegenerate(feedbackText, enhancePromptEnabled);
      setFeedbackText('');
      setShowFeedback(false);
    }
  };

  const isProcessing = isLoading || isStreaming;

  return (
    <div className={styles.feedbackContainer}>
      <div className={styles.buttonRow}>
        <button
          className={styles.toggleBtn}
          onClick={() => setShowFeedback(!showFeedback)}
        >
          {showFeedback ? (
            <><MdClose /> Close Feedback</>
          ) : (
            <><MdChat /> Provide Feedback & Regenerate</>
          )}
        </button>
      </div>

      {showFeedback && (
        <div className={styles.feedbackSection}>
          <div className={styles.header}>
            <h3 className={styles.title}>
              Refine Your Summary
            </h3>
            <p className={styles.description}>
              Tell us what you'd like to improve or change about the summary
            </p>
          </div>

          <textarea
            className={styles.textarea}
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
            placeholder="Example: Make it more concise, add technical details, simplify the language, focus on key findings..."
            disabled={isProcessing}
            rows={4}
          />

          <div className={styles.options}>
            <label className={styles.checkboxLabel}>
              <input
                type="checkbox"
                className={styles.checkbox}
                checked={enhancePromptEnabled}
                onChange={(e) => setEnhancePromptEnabled(e.target.checked)}
                disabled={isProcessing}
              />
              <div className={styles.checkboxText}>
                <span className={styles.checkboxMain}>
                  Enable Auto Prompt Engineering (recommended)
                </span>
              </div>
            </label>

            {enhancePromptEnabled && (
              <div className={styles.enhancementInfo}>
                <small>
                  Your feedback will be automatically enhanced with context and
                  clarity to help the AI better understand your requirements.
                </small>
              </div>
            )}
          </div>

          <div className={styles.footer}>
            <span className={styles.counter}>
              {feedbackText.length} characters
            </span>

            <div className={styles.actions}>
              {feedbackText.trim() && (
                <span className={styles.ready}>
                  <MdCheck /> Ready to regenerate
                </span>
              )}

              <button
                className={styles.regenerateBtn}
                onClick={handleSubmit}
                disabled={isProcessing}
              >
                {isProcessing ? (
                  <>
                    <MdHourglassEmpty />
                    Processing...
                  </>
                ) : (
                  <>
                    Regenerate
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

FeedbackSection.propTypes = {
  onRegenerate: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  isStreaming: PropTypes.bool.isRequired,
};

export default FeedbackSection;
